export const SELECTED_RESTAURANT_ID_KEY = "selectedRestaurantId";
export const SELECTED_RESTAURANT_NAME_KEY = "selectedRestaurantName";
